module.exports = __webpack_public_path__ + "img/captions-disabled.9f38a361.svg";